import React from "react"
import Grid from "@mui/material/Grid2"
import {Typography} from "@mui/material";
import ReturnToStartScreenTimer from "./ReturnToStartScreenTimer";
import {useTranslation} from "react-i18next";

interface ThankYouProps {
    message?: string
}

const ThankYou = ({ message }: ThankYouProps) => {
    const { t } = useTranslation();

    return (
        <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={4} className="pageMainContainer">
            <Grid/>
            <Grid alignContent="center" alignItems="center" style={{textAlign: 'center'}}>
                <Typography variant="h4" gutterBottom>
                    {t('selfService.thankYou')}
                </Typography>
                {message &&
                    <Typography variant="subtitle1" gutterBottom>
                        {message}
                    </Typography>
                }
            </Grid>
            <Grid>
                <ReturnToStartScreenTimer time={5}/>
            </Grid>
            <Grid/>
        </Grid>
    )
}

export default ThankYou
